<style src="./ProgressBar.scss" lang="scss" scoped></style>
<template lang="html">
  <div class="progress-bar">
    <div class="progress-infinite"></div>
    <!-- <div
      class="progress-indicator"
      :style="{ width: progress + '%' }"></div> -->
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    progress: {
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/progress-bar/ProgressBar.vue